import { Loader2 } from "lucide-react";

function formatYMD(s) {
  if (!s) return "—";
  // Accept "YYYY-MM-DD" or ISO; render as YYYY-MM-DD.
  const m = String(s).match(/\d{4}-\d{2}-\d{2}/);
  return m ? m[0] : s;
}

const TH =
  "px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#525252]";

export default function ReportRowsTable({ rows, loading, emptyText }) {
  return (
    <div className="bg-white border border-black/5 rounded-xl overflow-hidden">
      <div className="px-5 py-3 border-b border-black/5 flex items-center justify-between">
        <span
          className="text-xs font-semibold uppercase tracking-wider text-[#525252]"
          data-testid="result-count"
        >
          {rows.length} {rows.length === 1 ? "record" : "records"}
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="results-table">
          <thead>
            <tr className="bg-[#FAFAFA] border-b border-black/5 text-left">
              <th className={TH}>Serial Number</th>
              <th className={TH}>Vehicle Number</th>
              <th className={TH}>Category of Vehicle</th>
              <th className={TH}>Cylinder Serial No</th>
              <th className={TH}>QR Code Value</th>
              <th className={TH}>Cylinder Manufacturer Name</th>
              <th className={TH}>Last Test Date</th>
              <th className={TH}>Due Test Date</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={8}
                  className="px-4 py-10 text-center text-[#525252]"
                >
                  <Loader2 className="h-5 w-5 animate-spin inline-block text-[#F50E02]" />
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td
                  colSpan={8}
                  className="px-4 py-10 text-center text-[#525252]"
                  data-testid="empty-row"
                >
                  {emptyText || "No records match the selected filters."}
                </td>
              </tr>
            ) : (
              rows.map((r, idx) => (
                <tr
                  key={`${r.id || idx}-${r.cylinder_serial_number || idx}`}
                  className="border-b border-black/5 last:border-0 hover:bg-[#FAFAFA]/60"
                >
                  <td className="px-4 py-3 text-[#525252]">{idx + 1}</td>
                  <td className="px-4 py-3 font-medium text-[#0A0A0A]">
                    {r.vehicle_number || "—"}
                  </td>
                  <td className="px-4 py-3 text-[#0A0A0A]">
                    {r.vehicle_category_name || "—"}
                  </td>
                  <td className="px-4 py-3 text-[#0A0A0A]">
                    {r.cylinder_serial_number || "—"}
                  </td>
                  <td className="px-4 py-3 text-[#0A0A0A]">
                    {r.cylinder_qr_code || "—"}
                  </td>
                  <td className="px-4 py-3 text-[#0A0A0A]">
                    {r.cylinder_manufacturer_name || "—"}
                  </td>
                  <td className="px-4 py-3 text-[#525252]">
                    {formatYMD(r.cylinder_last_test_date)}
                  </td>
                  <td className="px-4 py-3 text-[#525252]">
                    {formatYMD(r.cylinder_due_test_date)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
